export default __webpack_public_path__ + "static/media/download-app-mockup.085dcc54.png";